import {
  Accordion,
  AccordionDetails,
  AccordionSummary, Box, Button,
  Checkbox,
  FormControlLabel,
  FormGroup, InputAdornment, TextField,
  Typography,
} from '@mui/material';
import React, {useContext, useEffect, useState} from "react";
import {FormDataContext} from "../../contexts/FormDataContext";
import {ExpandMore} from "@mui/icons-material";
import { SectionHeading } from '../SectionHeading';
import { SectionPaper } from '../SectionPaper';


export const Occupations = () => {
  const [occupationItems, setOccupationItems] = useState([]);
  const [originalOccupationItems, setOriginalOccupationItems] = useState([]);
  const [expandedAccordions, setExpandedAccordions] = useState([]);
  const [filterTerm, setFilterTerm] = useState('');

  const {
    occupations,
    selectedOccupations,
    setSelectedOccupations,
    preferencesFormDisabled,
    setIsFormDataChanged,
    // initialPreferencesData,
  } = useContext(FormDataContext);

  // useEffect(() => {
  //   if (initialPreferencesData.occupations) {
  //     const initialOccupations = initialPreferencesData.occupations;
  //     if (initialOccupations.length > 0) {
  //       setSelectedOccupations(initialOccupations);
  //     }
  //   }
  // }, [initialPreferencesData]);

  useEffect(() => {
    if (occupations.length > 0) {
      // Sort Occupations alphabetically for each Career Area.
      occupations.forEach(careerAreas => {
        careerAreas.codes.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
      });
      setOriginalOccupationItems(occupations);
      setOccupationItems(occupations);
    }
  }, [occupations]);

  const requestSearch = (event) => {
    const searchedVal = event.target.value;
    setFilterTerm(searchedVal);
    if (searchedVal.length > 0) {
      let occupationItemsFilteredCodes = [];
      const clonedOriginalOccupationItems = originalOccupationItems.map(
        careerArea => Object.assign({}, careerArea)
      );
      clonedOriginalOccupationItems.map(occupationItem => {
        occupationItem.codes = occupationItem.codes.filter(code => {
          return code.name.toLowerCase().includes(searchedVal.toLowerCase());
        });
        occupationItemsFilteredCodes.push(occupationItem);
      });
      const filteredOccupationItems = occupationItemsFilteredCodes.filter(occupationItem => {
        return occupationItem.codes.length > 0;
      });
      setOccupationItems(filteredOccupationItems);
    } else {
      setOccupationItems(originalOccupationItems);
    }
  };

  const handleClearFilter = () => {
    setFilterTerm('');
    setOccupationItems(originalOccupationItems);
  };

  const handleLocationChange = occupationCodeId => {
    if (selectedOccupations.includes(occupationCodeId)) {
      setSelectedOccupations(selectedOccupations.filter(
        selectedOccupationCodeId => selectedOccupationCodeId !== occupationCodeId
      ));
    } else {
      setSelectedOccupations([...selectedOccupations, occupationCodeId]);
    }
    setIsFormDataChanged(true);
  };

  const isExpanded = (accordionId) => {
    return expandedAccordions.includes(accordionId);
  };

  const toggleExpanded = accordionId => {
    if (expandedAccordions.includes(accordionId)) {
      setExpandedAccordions(expandedAccordions.filter(
        expandedAccordionId => expandedAccordionId !== accordionId
      ))
    } else {
      setExpandedAccordions([...expandedAccordions, accordionId]);
    }
  };

  const getSelectedCount = careerAreaCodes => {
    let codesSelectedText = '';
    let codesSelectedCount = 0;
    careerAreaCodes.map(code => {
      if (selectedOccupations.includes(code.code_id)) {
        codesSelectedCount++;
      }
    });
    if (codesSelectedCount > 0) {
      codesSelectedText = codesSelectedCount + ' selected';
    }
    return codesSelectedText;
  };

  return (
    <>
      <SectionHeading>
        Career Fields You Are Interested In
      </SectionHeading>
      <Box display="flex" alignItems="center" gap={2}>
        <TextField
          disabled={preferencesFormDisabled}
          onChange={(searchVal) => requestSearch(searchVal)}
          label="Filter occupations"
          sx={{marginTop: '10px', flexGrow:1}}
          value={filterTerm}
          InputProps={{
            endAdornment: (
              filterTerm && (
                <InputAdornment position="end">
                  <Button
                    variant="contained"
                    onClick={handleClearFilter}
                  >
                    Clear filter
                  </Button>
                </InputAdornment>
              )
            ),
          }}
        />
      </Box>
      <FormGroup>
        {occupationItems.map(careerArea => (
          <Box key={`careerArea${careerArea.id}`} sx={{marginTop: '6px'}}>
            <Accordion expanded={filterTerm ? true : isExpanded(careerArea.id)}>
              <AccordionSummary
                expandIcon={<ExpandMore/>}
                aria-controls={`accordion${careerArea.id}-content`}
                id={`accordion${careerArea.id}-header`}
                onClick={() => toggleExpanded(careerArea.id)}
              >
                <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                  <Typography>
                    {careerArea.name}
                  </Typography>
                  <Typography
                    sx={{ flexShrink: 0, textAlign: 'right', marginRight: '10px', opacity: 0.85 }}
                    variant={'subtitle1'}
                  >
                    {getSelectedCount(careerArea.codes)}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                {careerArea.codes.map(code => (
                  <div key={`code${code.code_id}`}>
                    <FormControlLabel key={`label${code.code_id}`} control={
                      <Checkbox
                        disabled={preferencesFormDisabled}
                        checked={selectedOccupations.includes(code.code_id)}
                        onChange={() => handleLocationChange(code.code_id)}
                      />
                    } label={code.name} />
                  </div>
                ))}
              </AccordionDetails>
            </Accordion>
          </Box>
        ))}
        {filterTerm && occupationItems.length === 0 &&
          <SectionPaper>
            No occupations match this filter.
          </SectionPaper>
        }
      </FormGroup>
    </>
  )
};
